import '~/webpack';
import '~/commons';
import initPerformanceBarAndLog from '~/performance_bar';

initPerformanceBarAndLog();
